import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';
import { useOneDriveTargetUserGroups } from '@Policy/hooks';
import { Box, Divider, Flex } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';

export const TargetUserGroupsOneDrive = () => {
  const props = useOneDriveTargetUserGroups();
  return <TargetUserGroups {...props} />;
};
const General = () => {
  const { t } = useTranslation();
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const mipAndTokenFeatureShow =
    !!selectedOrgGlobalSetting?.mipAndTokenFeatureShow;
  const rmsFeatureShow = !!selectedOrgGlobalSetting?.rmsFeatureShow;
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={false}
        mipEnableFeatureShow={mipAndTokenFeatureShow}
        rmsEnabledShow={!mipAndTokenFeatureShow && rmsFeatureShow}
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyTarget')} required />
        <TargetUserGroupsOneDrive />
      </Flex>
    </Box>
  );
};
export default React.memo(General);
